var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "box",
    {
      staticClass: "simple-place-search",
      class: { "extra-low-resolution": _vm.$xlResolution },
      style: { height: _vm.height + "px" },
      attrs: { background: "white" }
    },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs2: "", sm2: "", md1: "" } },
            [
              _c(
                "v-badge",
                {
                  attrs: { overlap: "", left: "", color: "info" },
                  model: {
                    value: _vm.showNewInfo,
                    callback: function($$v) {
                      _vm.showNewInfo = $$v
                    },
                    expression: "showNewInfo"
                  }
                },
                [
                  _c("b", { attrs: { slot: "badge" }, slot: "badge" }, [
                    _vm._v("i")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "smart-tooltip",
                          rawName: "v-smart-tooltip",
                          value: {
                            show: _vm.showRouteDetailsTooltip,
                            text: _vm.$t(
                              "simplePlaceSearch.openSidebarToSeeRouteDetails"
                            ),
                            position: "right",
                            dark: true
                          },
                          expression:
                            "{\n            show: showRouteDetailsTooltip,\n            text: $t('simplePlaceSearch.openSidebarToSeeRouteDetails'),\n            position: 'right',\n            dark: true\n          }"
                        }
                      ],
                      staticClass: "open-menu",
                      attrs: {
                        slot: "default",
                        title:
                          _vm.showNewInfo === true
                            ? _vm.$t(
                                "simplePlaceSearch.openSidebarToSeeRouteDetails"
                              )
                            : "",
                        flat: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.openMenu()
                        }
                      },
                      slot: "default"
                    },
                    [_c("v-icon", [_vm._v("menu")])],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs10: "", sm10: "", md11: "" } },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c("place-input", {
                    staticClass: "mini-input",
                    attrs: {
                      height: 27,
                      mb: 0,
                      index: 0,
                      "id-postfix": "simple-place-search",
                      model: _vm.place,
                      "directions-button-tooltip": _vm.showDirectionsBtnTooltip,
                      "directions-button-tooltip-position": "bottom",
                      autofocus: true,
                      single: true
                    },
                    on: {
                      selected: _vm.selectPlace,
                      startDirections: _vm.openDirectionsMode,
                      searchChanged: _vm.search,
                      focused: _vm.inputFocused,
                      cleared: _vm.placeCleared
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56d10be2", { render: render, staticRenderFns: staticRenderFns })
  }
}